import { jsxs, jsx } from 'react/jsx-runtime';
import cns from '../../node_modules/classnames/index.js';
import useMouseOver from '../Hooks/useMouseOver.js';

/**
Il componente visualizza un testo in pop over al mouse over.

_ATTENZIONE_ l'attuale implementazione ha dei problemi con certi tipi di overflow.
Può accadere infatti che il testo in pop over venga "coperto" da contenuti al di fuori del div che lo contiene.
Questo vale per tutti i componenti che lo utilizano (Ellipsis, InfoToolip).
 */
function TooltipOld({ children = undefined, left = false, right = false, top = false, content, enableFunction = undefined, className = undefined, }) {
    const [mostraInfo, onMouseOver, onMouseOut] = useMouseOver();
    const enable = !enableFunction || enableFunction();
    const classes = cns('infoTooltip', {
        'infoTooltip--left': left,
        'infoTooltip--right': right,
        'infoTooltip--top': top,
        'infoTooltip--enable': enable,
    }, className);
    return (jsxs("span", { className: classes, "data-clickable": "false", onMouseOver: onMouseOver, onFocus: onMouseOver, onMouseOut: onMouseOut, onBlur: onMouseOut, children: [children, mostraInfo && enable && (jsx("span", { className: "infoTooltip__content", "data-clickable": "false", children: content }))] }));
}

export { TooltipOld as default };
